import styles from './form_footer.module.scss';
import React from 'react';
import {classNames} from '../../support/classnames.ts';

interface OwnProps {
    children: React.ReactNode;
    gray?: boolean;
}

export function FormFooter({children, gray}: OwnProps) {
    return (
        <div
            className={classNames(styles.form_footer, {
                [styles.gray]: gray,
            })}
        >
            {children}
        </div>
    );
}
